
// Hack required to get jquery to work with bootstrap
import $ from "jquery"

window.$ = $
window.jQuery = $